var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.exportar()}}},[_c('v-icon',[_vm._v("download")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }